import { localizedTitle } from "@/lib/i18n/ssrSeo";
import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import { queryOptions } from "@tanstack/react-query";
import { getPublicUpcomingPicks, getDailyMemberPick } from "@/lib/publicPicks.functions";
import { hubJsonLd } from "@/lib/picksJsonLd";

const picksQuery = queryOptions({ queryKey: ["public-upcoming-picks"], queryFn: () => getPublicUpcomingPicks(), staleTime: 5 * 60_000 });
import Index from "@/pages/Index";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/")({
  loader: async ({ context }) => {
    const [picks] = await Promise.all([
      context.queryClient.ensureQueryData(picksQuery),
      context.queryClient.ensureQueryData({ queryKey: ["daily-member-pick"], queryFn: () => getDailyMemberPick(), staleTime: 5 * 60_000 }),
    ]);
    return picks;
  },
  head: ({ loaderData }) => {
    const L = localizedTitle("/", { title: "Statlign: AI Sports Predictions & Betting Tips Today", description: "Transparent, explainable sports picks from a 50-strategy AI engine. Every call ranked by conviction. Every reason on record. Free to inspect." });
    return {
    meta: [
      { name: "facebook-domain-verification", content: "lz6ibh9l9xc49p336gpm1d3y08jgtb" },
      { title: L.title },
      { name: "keywords", content: seoFor({ topics: ["predictions", "aiPredictions", "home", "nigeria"] }).meta },
      { name: "description", content: L.description },
      { property: "og:title", content: L.title },
      { property: "og:type", content: "website" },
      { property: "og:description", content: L.description },
      { name: "twitter:title", content: L.title },
      { name: "twitter:description", content: L.description },
    ],
    scripts: hubJsonLd({ path: "/", name: "Statlign AI sports predictions", description: "Upcoming AI-analysed football picks with odds, confidence and reasoning.", picks: (loaderData ?? []) }),
  };
  },
  component: () => (
    <MainLayout>
      <Index />
    </MainLayout>
  ),
});
